import React from 'react'
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import ColorLensOutlinedIcon from '@material-ui/icons/ColorLensOutlined';
import { Link, useLocation } from 'react-router-dom';
import { DownloadIcon } from '@heroicons/react/outline';


function ResumeNavbar({downloadRef}) {
    const { pathname } = useLocation()

    const exportPDFWithComponent = () => {
        console.log(downloadRef)
        if (downloadRef.current) {
            downloadRef.current.save();
        }
    };
    return (
        <>
            <div className=' bg-white rounded-xl'>
                <div className='grid grid-cols-3 gap-2 p-3'>
                    <div className={`resume-navlink ${pathname === '/resume/content' && 'active'}`}>
                        <Link to={`/resume/content`} className={`flex items-center justify-center py-3 px-4 hover:bg-gray-100 rounded-md no-underline ${pathname === '/resume/content' && 'bg-gray-100'}`}>
                            <DescriptionOutlinedIcon className=' text-gray-700 w-full mr-2' />
                            <span className='text-gray-700 manpro text-lg font-medium '>Content</span>
                        </Link>
                    </div>
                    <div className={`resume-navlink ${pathname === '/resume/design' && 'active'}`}>
                        <Link to={`/resume/design`} className={`flex items-center justify-center py-3 px-4 hover:bg-gray-100 rounded-md no-underline ${pathname === '/resume/design' && 'bg-gray-100'}`}>
                            <ColorLensOutlinedIcon className=' text-gray-700 w-full mr-2' />
                            <span className='text-gray-700 manpro text-lg font-medium no-underline'>Design</span>
                        </Link>
                    </div>
                    <div className={`hover:bg-gray-100 rounded-md`}>
                        <div onClick={exportPDFWithComponent} className={`flex items-center justify-center py-3 px-4  no-underline cursor-pointer`}>
                            <DownloadIcon className='w-6 text-gray-700' />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ResumeNavbar